<template>
  <section class="featured_carousel big_container modify-slider">
    <h2 class="card_heading featured_carousel_heading" v-html="shopifyData.secHeading" />

    <Swiper
      :modules="modules"
      :breakpoints="swiperOptions.breakpoints"
      :space-between="10"
      :centered-slides="true"
      :centered-slides-bounds="true"
      :loop="false"
      :speed="1200"
      :navigation="{
        nextEl: `.next-btn-${uniqueId}`,
        prevEl: `.prev-btn-${uniqueId}`,
      }"
    >
      <!-- Product Mode -->
      <template v-if="shopifyData.showProduct === 'true'">
        <SwiperSlide v-for="(value, i) in safeProducts" :key="i" class="featured_carousel_item">
          <a
            :href="value.productLink"
            class="featured_carousel_item_link"
            :aria-label="value.productImage.alt || value.productTitle + ' Product Link'"
          >
            <picture>
              <source :srcset="value.productImage.srcsetWebp" type="image/webp" sizes="397px" />
              <source :srcset="value.productImage.srcsetJpg" type="image/jpeg" sizes="397px" />
              <img
                :src="value.productImage.src"
                :alt="value.productImage.alt || 'Product Image'"
                :aria-label="value.productImage.alt || value.productTitle + ' Product Image'"
                class="grid_img featured_carousel_item_image"
                loading="lazy"
                :width="397"
                :height="397"
                :style="{ aspectRatio: 1 / 1 }"
              />
            </picture>
          </a>
        </SwiperSlide>
        <div :class="`swiper-button-next next-btn-${uniqueId}`"></div>
        <div :class="`swiper-button-prev prev-btn-${uniqueId}`"></div>
      </template>

      <!-- Box Mode -->
      <template v-else>
        <SwiperSlide v-for="(value, i) in safeBoxes" :key="i">
          <div class="grid_item featured_carousel_item">
            <a
              :href="value.link"
              class="grid_img-wrap"
              :aria-label="value.imgUrl.alt || 'Featured Carousel Image'"
            >
              <img
                v-lazy="value.imgUrl.src"
                :src-placeholder="value.imgUrl.placeholder"
                :alt="value.imgUrl.alt || 'Featured Carousel Image'"
                :aria-label="value.imgUrl.alt || 'Featured Carousel Image'"
                loading="lazy"
                class="grid_img"
              />
            </a>
          </div>
        </SwiperSlide>
        <div :class="`swiper-button-next next-btn-${uniqueId}`"></div>
        <div :class="`swiper-button-prev prev-btn-${uniqueId}`"></div>
      </template>
    </Swiper>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper';
import 'swiper/css';

export default {
  components: { Swiper, SwiperSlide },
  props: {
    shopifyData: { type: Object, required: true },
  },

  setup() {
    return { modules: [Navigation] };
  },
  data() {
    return {
      isSwiperReady: false,
      swiperOptions: {
        breakpoints: {
          100: {
            slidesPerView: 2,
          },
          300: {
            slidesPerView: 2,
          },
          575: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
            slidesPerGroup: 1,
          },
          1440: {
            slidesPerView: 5,
            slidesPerGroup: 1,
          },
          1600: {
            slidesPerView: 6,
            slidesPerGroup: 1,
          },
        },
      },
      uniqueId: 'slider-' + Math.random().toString(36).substr(2, 9),
    };
  },

  computed: {
    safeProducts() {
      const products = this.shopifyData.product;
      if (!products?.length) return [];

      // Ensures loop works properly
      if (products.length < 6) {
        return [...products, ...products, ...products];
      }
      return products;
    },
    safeBoxes() {
      return this.shopifyData.box.length < 5
        ? [...this.shopifyData.box, ...this.shopifyData.box]
        : this.shopifyData.box;
    },
  },
  mounted() {
    this.isSwiperReady = true;
    // console.log("Slider Ready:", this.uniqueId);
  },
};
</script>

<style scoped>
.swiper-slide,
.swiper-wrapper {
  transition-timing-function: ease;
}

.img-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
}

.freatrue-carousel-product-image {
  position: relative;
  aspect-ratio: 1/1;
}

.nested-enter-active .inner,
.nested-leave-active .inner {
  transition: all 0.5s ease-in-out;
}

.nested-enter-from .inner,
.nested-leave-to .inner {
  transform: translateY(-30px);
  opacity: 0;
}

@keyframes wave-squares {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}

.featured_carousel_item {
  position: relative;
  aspect-ratio: 1/1;
  overflow: hidden;
  background: linear-gradient(90deg, #e8e8e8 25%, #d8d8d8 50%, #e8e8e8 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.featured_carousel_item img,
.featured_carousel_item .grid_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.swiper-slide {
  backface-visibility: hidden;
  transform: translateZ(0);
}

.featured_carousel {
  background: #f1f1f1;
  padding: 20px 0 60px;
}

.featured_carousel_heading {
  margin: 0px 0 20px 15px;
}

.featured_carousel .swiper {
  padding-left: 15px;
}

@media only screen and (max-width: 991px) {
  .featured_carousel .swiper {
    padding-left: 5px;
  }
}

@media only screen and (max-width: 768px) {
  .featured_carousel {
    padding: 10px 0 50px;
  }
}

@media only screen and (max-width: 480px) {
  .featured_carousel .swiper-slide {
    max-width: 70%;
  }
  .img-placeholder {
    width: 100%;
    height: 152px;
  }
}
</style>
